import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ResponseDataInterface } from '@interface/logs/response-data.interface';
import {
  UserGuidesInterface,
  UserInterface,
  UserMetaInterface,
  UserProfileInterface,
  UserSettingsInterface,
} from '@interface/user/user.interface';
import { baseReducerActions } from '@util/data/base-reducer-actions';

import { initialUserState } from './user.initial-state';

export const userSlice = createSlice({
  name: 'user',
  initialState: initialUserState,
  reducers: {
    ...baseReducerActions(initialUserState),
    setMeta: (state, { payload }: PayloadAction<ResponseDataInterface<UserMetaInterface>>) => {
      state.meta = payload.data;
    },
    setUser: (state, { payload }: PayloadAction<ResponseDataInterface<UserInterface>>) => {
      state.data = {
        ...state.data,
        ...payload.data,
      };
    },
    setProfile: (state, { payload }: PayloadAction<ResponseDataInterface<UserProfileInterface>>) => {
      state.data.profile = payload.data;
    },
    setSettings: (state, { payload }: PayloadAction<ResponseDataInterface<UserSettingsInterface>>) => {
      state.data.settings = payload.data;
    },
    setGuides: (state, { payload }: PayloadAction<ResponseDataInterface<UserGuidesInterface>>) => {
      state.data.guides = { ...state.data.guides, ...payload.data };
    },
  },
});

export const userActions = userSlice.actions;
